import {
  createContext,
  useState,
  useEffect,
  useCallback,
  useContext,
  useMemo
} from 'react';
import * as TemplateApi from '../Api/Template';
import * as usersApi from '../Api/Users';
import * as templateCategoryApi from '../Api/TemplateCategory';
import * as categoryApi from '../Api/Category';
export const TemplateContext = createContext();
export const useTemplate = () => useContext(TemplateContext);

export const UpdateTemplate = () => {
  const { updateTemplate } = useTemplate();
  return updateTemplate;
};

export const TemplateProvider = ({
  children
}) => {
  const [initialLoad, setInitialLoad] = useState(false);
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);

  const [templateCategories, setTemplateCategories] = useState([]);
  const [currentCategory, setCurrentCategory] = useState()
  const [defaultCategories, setDefaultCategories] = useState()

  const refreshTemplate = useCallback(async() => {
    if(localStorage.getItem("auth_token") != null){
      try {
        setError();
        setLoading(true);
        var data = await TemplateApi.getTemplateByName(localStorage.getItem("userID"))
        console.log(data)
        if(data === ""){
          data = await usersApi.getUserById(localStorage.getItem("userID"))
          data = await TemplateApi.getTemplate(data.user.role.templateID)
          data = data[0]
        }
        const c = [];
        console.log(data)
        data.template.forEach(t=> localStorage.setItem(t.name,t.layout))
        data.templatecategory.forEach(element => {
          if(data.template.filter((item) => item.name === element.category.categoryName)[0] != null)
          console.log(element.category)
            c.push(element.category)
        });
        const a = []
        c.forEach((category) => {
            a.push({value: category.categoryName, label: category.categoryName})
        });
        setDefaultCategories(a)
        setTemplateCategories(c);
        setCurrentCategory(c[0])
        return data;
    } catch (error) {
        setError(error);
    } finally {
        setLoading(false)
    }
    }
  }, []);
  const updateCurrentCategory = useCallback(async(category) => {
    setCurrentCategory(category)
  },[])
  const updateTemplate = useCallback(async(json,selectedCategories) => {
    try {
      setError();
      setLoading(true);
      var template = await TemplateApi.getTemplateByName(localStorage.getItem("userID"))
      const categories = await categoryApi.getAllCategory();
      if(template === ""){
        const data = await TemplateApi.createTemplate(localStorage.getItem("userID"),json,localStorage.getItem("userID"));
        await usersApi.updateUserTemplate(localStorage.getItem("userID"),data.templateID)
        json.forEach(async (item) => {
          const cat = categories.filter(i => i.categoryName === item.name)[0];
          await templateCategoryApi.createTemplate(cat.categoryID,data.templateID)
        })
      }  
      else{
        await templateCategoryApi.deleteTemplate(template.templateID)
        await TemplateApi.updateTemplate(template.templateID,json)
        json.forEach(async (item) => {
          const cat = categories.filter(i => i.categoryName === item.name)[0];
          await templateCategoryApi.createTemplate(cat.categoryID,template.templateID)
        })
      }
      refreshTemplate();
    } catch (error) {
      setError(error);
  } finally {
      setLoading(false)
  }
  },[refreshTemplate])


  useEffect(() => {
      if (!initialLoad) {
        refreshTemplate();
        setInitialLoad(true);
      }
  }, [initialLoad, refreshTemplate]);


  const value = useMemo(() => ({
      refreshTemplate,
      updateTemplate,
      templateCategories,
      initialLoad,
      error,
      loading,
      currentCategory,
      defaultCategories,
      updateCurrentCategory
  }), [refreshTemplate,updateTemplate,templateCategories,initialLoad, error, loading,currentCategory,defaultCategories,updateCurrentCategory]);

  return ( <TemplateContext.Provider value = {value} > {
          children
      } </TemplateContext.Provider>
  );
};